<template>
	<v-card-text>
		<h4>
			<slot name="title" />
		</h4>
		<v-divider />
		<v-simple-table dense>
			<thead>
			<tr>
				<th>Наименование</th>
				<th class="text-right" style="width: 24%">Цена</th>
				<th class="text-right" style="width: 17%">{{ amountTitle }}</th>
				<th></th>
			</tr>
			</thead>
			<tbody>
			<template v-if="positions.length">
				<tr
					v-for="position in positions"
					:key="`position-${position.id}`"
				>
					<td>{{ position.name }}</td>
					<td class="text-right">{{ position.price }}</td>
					<td class="text-right">{{ position.amount }}</td>
					<td>
						<v-btn
							x-small
							icon
							@click="deletePosition(position)"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</td>
				</tr>
			</template>
			<tr v-else>
				<td colspan="4">
					<div class="text-center">
						<slot name="empty" />
					</div>
				</td>
			</tr>

			<tr style="border-top: 1px solid black">
				<td style="padding-left: 1px; padding-right: 1px;">
					<input
						ref="firstInput"
						v-model="form.name"
						placeholder="Наименование"
						class="px-2"
						style="border: 1px solid grey; border-radius: 5px; width: 100%"
						name="name"
						:disabled="loading"
						@keypress.enter="createPosition"
					>
				</td>
				<td style="padding-left: 1px; padding-right: 1px;">
					<input
						v-model="form.price"
						placeholder="Цена"
						class="px-1"
						style="border: 1px solid grey; border-radius: 5px; width: 100%"
						name="price"
						type="number"
						min="0"
						:disabled="loading"
						@keypress.enter="createPosition"
					>
				</td>
				<td style="padding-left: 1px; padding-right: 1px;">
					<input
						v-model="form.amount"
						:placeholder="amountTitle"
						class="px-1"
						style="border: 1px solid grey; border-radius: 5px; width: 100%"
						name="amount"
						type="number"
						min="0"
						:disabled="loading"
						@keypress.enter="createPosition"
					>
				</td>
				<td>
					<v-btn
						x-small
						icon
						@click="createPosition"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</td>
			</tr>
			</tbody>
		</v-simple-table>
	</v-card-text>
</template>

<script>
import axios from 'axios';

const TYPES = [
	{ key: 'part', name: 'Деталь' },
	{ key: 'work', name: 'Работа' },
];

const EMPTY_FORM = () => ({
	type: null,
	name: null,
	price: null,
	amount: null,
});

export default {
	name: 'RepairOrderPositionsTable',
	props: {
		orderId: {
			type: Number,
			required: true,
		},
		positions: {
			type: Array,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
		defaultPrice: {
			type: Number,
			default: null,
		},
	},
	data: () => ({
		loading: false,
		form: EMPTY_FORM(),
	}),
	computed: {
		amountTitle() {
			return this.type === 'work'
				? 'Часов'
				: 'Кол-во';
		},
	},
	mounted() {
		this.clearForm();
		this.CancelToken = axios.CancelToken;
		this.source = this.CancelToken.source();
	},
	methods: {
		async createPosition() {
			if (this.loading) return;
			this.loading = true;
			try {
				this.form.type = this.type;
				const response = await this.$http.post(`/api/v2/service/orders/repair/${this.orderId}/positions`, this.form);
				this.$emit('created', response.data.data);
				this.clearForm();
				// todo focus on ref firstInput
			} finally {
				this.loading = false;
			}
		},
		async deletePosition(position) {
			if (!confirm(`Вы уверены, что хотите удалить позицию "${position.name}"?`)) return;
			try {
				await this.$http.delete(`/api/v2/service/orders/repair/positions/${position.id}`);
				this.$emit('deleted', position);
			} catch (e) {
				this.$notify.error('Ошибка удаления запчасти');
			}
		},
		clearForm() {
			this.form = EMPTY_FORM();
			this.form.price = this.defaultPrice;
		},
	},
};
</script>

<style lang="scss">
.v-input.extra-small-autocomplete {
	div.v-input__control {
		max-height: 23px;
	}

	div.v-input__slot {
		min-height: 20px !important;
	}

	div.v-input__append-inner {
		margin-top: 0 !important;
	}

	input {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
		font-size: 14px;
	}
}
</style>
